var app = {
	header: {
		build: "Build",
		closeButton: "Închide",
		copyrightLabel: "Drepturi de autor",
		helpLabel: "Ajutor",
		legalNoticeLabel: "Notă legală",
		logoutButton: "Deconectare",
		menuLabel: "Meniu",
		module: "Modul",
		noUserDataLabel: "Nu există date ale utilizatorului disponibile",
		notificationsLabel: "Notificări",
		privacyPolicyLabel: "Politica de confidențialitate",
		serviceAppLabel: "Aplicație de serviciu",
		settingsLabel: "Setări",
		shopLabel: "Magazin",
		smartFactorySuiteLabel: "Pachet Smart-Factory",
		softwareInformation: "Informații software",
		userLabel: "Profil",
		userProfileLinkText: "Profilul utilizatorului",
		version: "Versiune"
	}
};
var contentLoadingError = "Conținutul nu a putut fi încărcat";
var dashboard = {
	cancel: {
		button: "Anulează"
	},
	edit: {
		button: "Editează"
	},
	reset: {
		button: "Resetează"
	},
	save: {
		button: "Salvează"
	},
	share: {
		button: "Partajează"
	}
};
var filter = {
	clear: "Resetează filtrele",
	clearAll: "Resetează toate filtrele"
};
var locationMap = {
	locationLink: {
		label: "Mergi la locație"
	}
};
var machineDiscontinuation = {
	linkText: "Aflați mai multe"
};
var notifications = {
	button: {
		loadMore: "Încarcă mai multe"
	},
	date: {
		lastMonth: "Luna trecută",
		lastWeek: "Săptămâna trecută",
		older: "Mai vechi",
		thisMonth: "Luna aceasta",
		thisWeek: "Săptămâna aceasta",
		today: "Astăzi",
		yesterday: "Ieri"
	},
	error: {
		general: "În prezent, nu se pot afișa notificări. Vă rugăm să încercați din nou mai târziu.",
		unauthorized: "Vă rugăm să vă autentificați pentru a vedea notificările"
	},
	info: {
		activateSettings: "Pentru a primi notificări, vă rugăm să le activați în setări",
		noNotification: "În prezent, nu aveți mesaje."
	},
	title: "Notificări"
};
var results = {
	counter: {
		label: "rezultate"
	}
};
var scrollToTop = {
	label: "Derulează sus"
};
var slider = {
	nextButton: {
		label: "Slide-ul următor"
	},
	paginationBullet: {
		label: "Slide"
	},
	prevButton: {
		label: "Slide-ul anterior"
	}
};
var sorting = {
	ascending: "Ascendent",
	descending: "Descendent"
};
var userAccount = {
	address: {
		label: "Adresa poștală"
	},
	email: {
		label: "Email"
	},
	language: {
		label: "Limbă",
		locale: "Localizare",
		select: "Selectați limba",
		settings: "Setări limbă"
	},
	loggedOut: {
		message: "Nu sunteți conectat"
	},
	login: {
		button: "Autentificare"
	},
	name: {
		label: "Nume"
	},
	phone: {
		label: "Telefon"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Filtrează mașinile",
			label: "Mașini",
			option: {
				all: "Toate mașinile"
			},
			select: "Selectează mașina"
		},
		period: {
			label: "Perioadă",
			option: {
				currentMonth: "Luna aceasta",
				currentWeek: "Săptămâna aceasta",
				lastMonth: "Luna trecută",
				lastWeek: "Săptămâna trecută",
				today: "Astăzi",
				yesterday: "Ieri"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Widget-urile mele"
	},
	noDescriptionAvailable: "Descriere indisponibilă.",
	widget: {
		SampleMyMachines: {
			title: "Mașinile mele"
		},
		SampleMyServiceCalls: {
			title: "Apeluri de serviciu"
		},
		SampleMyTrackingList: {
			title: "Lista de urmărire"
		},
		SampleMyUserAccount: {
			title: "Profilul meu"
		},
		SampleOperationalStatesChart: {
			title: "Stările operaționale"
		},
		SampleWidgetFilter: {
			title: "Setările filtrului"
		},
		SampleWorkloadBalanceChart: {
			title: "Echilibrul sarcinii de lucru"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	filter: filter,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, filter, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
